

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { Reference } from '@/models/references/reference';
import { ReferenceBasicData as ReferenceBasicDataModel } from '@/models/references/reference-basic-data';
import { ReferenceType } from '@/models/references/reference-type';
import { ReferenceSkuType } from '@/models/references/reference-sku-type';
import { authorizationManagerService, referencesService, notificationsService, usersService } from '@/services';

@Component({
    components: {
        FormModal: () => import('@/components/shared/FormModal.vue'),
        ReferenceBasicData: () => import('@/components/references/ReferenceBasicData.vue')
    }
})
export default class EditReferenceBasicData extends Vue {
    @Prop(Reference) private reference!: Reference;
    @Prop({ type: Boolean, default: false }) private show?: boolean;
    private actualUserCanCreateReferences: boolean = false;
    private savingReference: boolean = false;

    private get referenceBasicData(): ReferenceBasicDataModel {
        return this.reference
            ? new ReferenceBasicDataModel({
                  id: this.reference.id,
                  type: this.reference.type,
                  projectId: this.reference.projectId,
                  businessId: this.reference.businessId,
                  categoryId: this.reference.category ? this.reference.category.id : null,
                  title: this.reference.title,
                  description: this.reference.description,
                  principalSkuCode: this.reference.principalSku ? this.reference.principalSku.code : null,
                  principalSkuPrice: this.reference.principalSku ? this.reference.principalSku.price : null,
                  principalSkuPriceDetails: this.reference.principalSku ? this.reference.principalSku.priceDetails : null,
                  depositSkuPrice: this.reference.skus.some(s => s.type === ReferenceSkuType.Deposit) ? this.reference.skus.find(s => s.type === ReferenceSkuType.Deposit)!.price : null,
                  totalValueSkuPrice: this.reference.skus.some(s => s.type === ReferenceSkuType.TotalValue) ? this.reference.skus.find(s => s.type === ReferenceSkuType.TotalValue)!.price : null,
                  particularConditions: this.reference.particularConditions
              })
            : new ReferenceBasicDataModel();
    }

    private mounted(): void {
        this.actualUserCanCreateReferences = authorizationManagerService.canCreateReferences;
    }

    private async saveReference(): Promise<void> {
        this.savingReference = true;

        if ((this.$refs.referenceData as any).hasErrors()) {
            this.savingReference = false;
            return;
        }

        try {
            if (await referencesService.updateReference(this.referenceBasicData)) {
                notificationsService.showToastSuccessNotification('components.services.editService.notification.successMessage');

                this.$emit('dataWasSaved');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: this.reference.type === ReferenceType.Product ? UserActionEntityType.Products : UserActionEntityType.Services,
                        scope: UserActionScopeType.Edit,
                        entityId: this.reference.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingReference = false;
        }
    }

    private async closeEditReference(): Promise<void> {
        this.$emit('closeModal');
    }
}
